module.exports = __webpack_public_path__ + "img/demo9.5e48f7df.jpg";